import { baseApi } from "../baseApi";
import { Customer } from "../../types";

const conversationsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getConversations: builder.query<
      Customer[],
      { page: number; limit: number }
    >({
      query: ({ page, limit }) => ({
        url: "conversations",
        params: { page, limit },
      }),
    }),
    sendEmail: builder.mutation<
      void,
      { customerId: number; subject: string; message: string; moveId?: number }
    >({
      query: ({ customerId, subject, message, moveId }) => ({
        url: `conversations/send_email`,
        method: "POST",
        body: { customer_id: customerId, subject, message, move_id: moveId },
      }),
    }),
    sendText: builder.mutation<
      void,
      { customerId: number; message: string; moveId?: number }
    >({
      query: ({ customerId, message, moveId }) => ({
        url: `conversations/send_text`,
        method: "POST",
        body: { customer_id: customerId, message, move_id: moveId },
      }),
    }),
    markAsRead: builder.mutation<void, { customerId: number }>({
      query: ({ customerId }) => ({
        url: `conversations/mark_as_read`,
        method: "POST",
        body: { customer_id: customerId },
      }),
    }),
    getMessageMediaContent: builder.query<
      { url: string },
      { messageId: number; mediaId: number }
    >({
      query: ({ messageId, mediaId }) => ({
        url: `messages/${messageId}/media/${mediaId}/content`,
      }),
    }),
  }),
});

export const {
  useGetConversationsQuery,
  useSendEmailMutation,
  useSendTextMutation,
  useMarkAsReadMutation,
  useGetMessageMediaContentQuery,
  useLazyGetMessageMediaContentQuery,
} = conversationsApi;
